import { BaseAction } from "../../../core/actions/BaseAction";
import { getRecoilState, updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ILocation, SearchStateType } from "../../../Orchestrator/Types/Index";

export class SelectOriginDestinationAction extends BaseAction<
  Partial<SearchStateType>,
  Partial<ILocation>
> {
  override async run(): Promise<Partial<SearchStateType>> {
    let searchData: Partial<SearchStateType> = {};
    try {
      const { field, id, name, search, isFromPopUp, searchPopup, isShuttle, geoPosition } =
        this.params!;
      // When the user picks, in one field, the station currently set in the
      // other field, clear that other field instead of leaving a duplicate.
      const otherField = field === "from" ? "to" : field === "to" ? "from" : undefined;
      const buildModifiedData = (base: Partial<SearchStateType> | undefined) => {
        const next: any = {
          ...base,
          [field!]: id,
          [`${field}Name`]: name,
          [`${field}Shuttle`]: isShuttle,
          [`${field}fmlmSearch`]: false,
          [`${field}GeoPosition`]: {
            latitude: geoPosition?.latitude,
            longitude: geoPosition?.longitude,
          },
        };
        if (otherField && id && next[otherField] === id) {
          next[otherField] = "";
          next[`${otherField}Name`] = "";
          next[`${otherField}Shuttle`] = false;
          next[`${otherField}fmlmSearch`] = false;
          next[`${otherField}GeoPosition`] = { latitude: undefined, longitude: undefined };
        }
        return next as Partial<SearchStateType>;
      };
      if (search) {
        if (isFromPopUp) {
          const modifiedData = buildModifiedData(searchPopup);
          updateRecoilState("searchStatePopupAtom", modifiedData);
          searchData = modifiedData;
        } else {
          const modifiedData = buildModifiedData(search);
          updateRecoilState("searchStateAtom", modifiedData);
          searchData = modifiedData;
        }

        if (field == "from") {
          updateRecoilState("isSelectingOriginAtom", false);
          updateRecoilState("isSelectingDestinationAtom", true);
        } else if (field == "to") {
          updateRecoilState("isSelectingDestinationAtom", false);
        }
        updateRecoilState("subStationDropdownAtom", {});
      }
    } catch (error) {
      console.error("Error in SelectOriginDestinationAction:", error);
    } finally {
      return searchData;
    }
  }
}

// Create a singleton instance
export const selectOriginDestinationAction = new SelectOriginDestinationAction();